var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettingsLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16.5999449px",
    height: "16.5999449px",
    viewBox: "0 0 16.5999449 16.5999449",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gestionnaire---Param\\xE8tres---Cat\\xE9gories",
    transform: "translate(-222.700028, -120.700028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(40.000000, 103.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(181.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 20 0 20 20 0 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60416667,3.5975 C8.95916667,2.13416667 11.0408333,2.13416667 11.3958333,3.5975 C11.5038692,4.04338267 11.8183614,4.41085354 12.2422096,4.58645484 C12.6660578,4.76205615 13.1482842,4.72466772 13.54,4.48583333 C14.8258333,3.7025 16.2983333,5.17416667 15.515,6.46083333 C15.2765104,6.85237825 15.2392122,7.33423422 15.4146066,7.75781597 C15.5900011,8.18139772 15.957024,8.49583457 16.4025,8.60416667 C17.8658333,8.95916667 17.8658333,11.0408333 16.4025,11.3958333 C15.9566173,11.5038692 15.5891465,11.8183614 15.4135452,12.2422096 C15.2379438,12.6660578 15.2753323,13.1482842 15.5141667,13.54 C16.2975,14.8258333 14.8258333,16.2983333 13.5391667,15.515 C13.1476217,15.2765104 12.6657658,15.2392122 12.242184,15.4146066 C11.8186023,15.5900011 11.5041654,15.957024 11.3958333,16.4025 C11.0408333,17.8658333 8.95916667,17.8658333 8.60416667,16.4025 C8.4961308,15.9566173 8.18163855,15.5891465 7.75779037,15.4135452 C7.33394218,15.2379438 6.85171576,15.2753323 6.46,15.5141667 C5.17416667,16.2975 3.70166667,14.8258333 4.485,13.5391667 C4.72348961,13.1476217 4.76078782,12.6657658 4.58539336,12.242184 C4.4099989,11.8186023 4.04297601,11.5041654 3.5975,11.3958333 C2.13416667,11.0408333 2.13416667,8.95916667 3.5975,8.60416667 C4.04338267,8.4961308 4.41085354,8.18163855 4.58645484,7.75779037 C4.76205615,7.33394218 4.72466772,6.85171576 4.48583333,6.46 C3.7025,5.17416667 5.17416667,3.70166667 6.46083333,4.485 C7.29416667,4.99166667 8.37416667,4.54333333 8.60416667,3.5975 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 10,
    cy: 10,
    r: 2.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettingsLight);
export default __webpack_public_path__ + "static/media/icon_settings_light.603c36301eca25aacf6e84bb228d9b05.svg";
export { ForwardRef as ReactComponent };